import {
  faExclamationCircle,
  faChevronLeft,
  faChevronRight,
  faCheck,
  faCircleInfo
} from '@fortawesome/pro-solid-svg-icons'

const solidIcons = [faExclamationCircle, faChevronLeft, faChevronRight, faCheck, faCircleInfo]

export default solidIcons
